<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col col-md-12">
        <pr-input-column label="Précisez le montant exact" [derrors]="derrors">
          <input
            notdot
            formControlName="scpiTotalInvestmentAmount"
            type="number"
            placeholder="Exemple : 100 000€"
          />
        </pr-input-column>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
